import GetNoticeDummyData from "../../../dummy/GetNoticeDummyData.json";
import SaveNoticeDummyData from "../../../dummy/SaveNoticeDummyData.json";
import UpdateNoticeDummyData from "../../../dummy/UpdateNoticeDummyData.json";
import DeleteNoticeDummyData from "../../../dummy/DeleteNoticeDummyData.json";
import GetGuideListDummyData from "../../../dummy/GetGuideListDummyData.json";
import SaveGuideDummyData from "../../../dummy/SaveGuideDummyData.json";
import UpdateGuideDummyData from "../../../dummy/UpdateGuideDummyData.json";
import DeleteGuideDummyData from "../../../dummy/DeleteGuideDummyData.json";
import GetCourseImagesDummyData from "../../../dummy/GetCourseImagesDummyData.json";
import UploadCourseImageDummyData from "../../../dummy/UploadCourseImageDummyData.json";
import DeleteCourseImageDummyData from "../../../dummy/DeleteCourseImageDummyData.json";
import UpdateCoursePriceDummyData from "../../../dummy/UpdateCoursePriceDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import NoticeDto from "../dto/settings/NoticeDto";
import GuideDto from "../dto/settings/GuideDto";

class FakeSettingsApi {
    // ===================== Notice =====================

    getNotice = async (): Promise<SuccessResponse<NoticeDto>> => {
        return GetNoticeDummyData as SuccessResponse<NoticeDto>;
    };

    saveNotice = async (): Promise<SuccessResponse<object>> => {
        return SaveNoticeDummyData;
    };

    updateNotice = async (): Promise<SuccessResponse<object>> => {
        return UpdateNoticeDummyData;
    };

    deleteNotice = async (): Promise<SuccessResponse<object>> => {
        return DeleteNoticeDummyData;
    };

    // ===================== Guide =====================

    getGuideList = async (): Promise<SuccessResponse<GuideDto[]> & { count?: number; totalCount?: number }> => {
        return GetGuideListDummyData as SuccessResponse<GuideDto[]> & { count?: number; totalCount?: number };
    };

    saveGuide = async (): Promise<SuccessResponse<[boolean, number]>> => {
        return SaveGuideDummyData as SuccessResponse<[boolean, number]>;
    };

    updateGuide = async (): Promise<SuccessResponse<boolean>> => {
        return UpdateGuideDummyData as SuccessResponse<boolean>;
    };

    deleteGuide = async (): Promise<SuccessResponse<boolean>> => {
        return DeleteGuideDummyData as SuccessResponse<boolean>;
    };

    // ===================== Course Image & Price =====================

    getCourseImages = async (): Promise<SuccessResponse<object>> => {
        return GetCourseImagesDummyData as SuccessResponse<object>;
    };

    uploadCourseImage = async (): Promise<SuccessResponse<string>> => {
        return UploadCourseImageDummyData as SuccessResponse<string>;
    };

    deleteCourseImage = async (): Promise<SuccessResponse<string>> => {
        return DeleteCourseImageDummyData as SuccessResponse<string>;
    };

    updateCoursePrice = async (): Promise<SuccessResponse<{ status: string }>> => {
        return UpdateCoursePriceDummyData as SuccessResponse<{ status: string }>;
    };
}

export default FakeSettingsApi;
